module.exports = __webpack_public_path__ + "img/cap_10.a81d5838.jpg";